// extracted by mini-css-extract-plugin
export default {"button":"slovo_button__gmgCl","buttonbase":"slovo_buttonbase__ciH34","buttonm":"slovo_buttonm__AYnD9","buttonf":"slovo_buttonf__a92iL","buttonru":"slovo_buttonru__dQX4W"};